import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ApiService, CurrentUser } from 'src/app/services/api.service';

@Component({
    selector: 'app-landing',
    templateUrl: './landing.component.html',
    styleUrls: ['./landing.component.scss'],
})
export class LandingComponent implements OnInit {
    ngOnInit() { }

    constructor(private api: ApiService, private cd: ChangeDetectorRef) {} 
}